import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IConnectorData, IConnectorProps, ICTConnectionDmlA, DeltaOf } from '@tencent/slide-sdk-model';
import { DeepPartial, DeepReadonly } from 'ts-essentials';
import _set from 'lodash/set';

/**
 * 连接线独有属性
 */
export class ConnectorInfoConverter {
    /**
     * 连接线独有属性的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<IConnectorProps>>,
        uiData: IConnectorModel,
    ): void {
        // 连接线连接的图形信息
        ConnectorInfoConverter.convertConnectElementDataSdkToUi(sdkData, uiData);
    }

    /**
     * 连接线独有属性的ui -> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IConnectorModel>>,
        sdkData: DeltaOf<IConnectorData>,
    ): void {
        // 连接线连接的图形信息
        ConnectorInfoConverter.convertConnectElementDataUiToSdk(uiData, sdkData);
    }

    /**
     * 连接线连接的图形信息
     * @param sdkData
     * @param uiData
     */
    // eslint-disable-next-line complexity
    private static convertConnectElementDataSdkToUi(
        sdkData: DeepReadonly<DeepPartial<IConnectorProps>>,
        uiData: IConnectorModel,
    ): void {
        const stCxn = sdkData.nvPr?.stCxn;
        const endCxn = sdkData.nvPr?.endCxn;
        uiData.props.style.connectorInfo = uiData.props.style.connectorInfo || {};
        const { connectorInfo } = uiData.props.style;
        // 连接线头部关联信息
        if (stCxn && Object.keys(stCxn).length) {
            connectorInfo.start = connectorInfo.start || {};
            if (stCxn.id) {
                connectorInfo.start.id = stCxn.id;
            }
            if (stCxn.idx || stCxn.idx === 0) {
                connectorInfo.start.index = stCxn.idx;
            }
        } else {
            delete connectorInfo.start;
        }
        // 连接线尾部关联信息
        if (endCxn && Object.keys(endCxn).length) {
            connectorInfo.end = connectorInfo.end || {};
            if (endCxn.id) {
                connectorInfo.end.id = endCxn.id;
            }
            if (endCxn.idx || endCxn.idx === 0) {
                connectorInfo.end.index = endCxn.idx;
            }
        } else {
            delete connectorInfo.end;
        }
    }

    /**
     * 连接线连接的图形信息
     * @param uiData
     * @param sdkData
     */
    // eslint-disable-next-line complexity
    private static convertConnectElementDataUiToSdk(
        uiData: DeepReadonly<DeepPartial<IConnectorModel>>,
        sdkData: DeltaOf<IConnectorData>,
    ): void {
        if (!uiData.props?.style?.connectorInfo) {
            return;
        }
        const { connectorInfo } = uiData.props.style;
        if (connectorInfo.start && Object.keys(connectorInfo.start).length) {
            const obj: ICTConnectionDmlA = {};
            if (connectorInfo.start.id) {
                obj.id = connectorInfo.start.id;
            }
            if (connectorInfo.start.index || connectorInfo.start.index === 0) {
                obj.idx = connectorInfo.start.index;
            }
            _set(sdkData, 'nvPr.stCxn', obj);
        }
        if (connectorInfo.end && Object.keys(connectorInfo.end).length) {
            const obj: ICTConnectionDmlA = {};
            if (connectorInfo.end.id) {
                obj.id = connectorInfo.end.id;
            }
            if (connectorInfo.end.index || connectorInfo.end.index === 0) {
                obj.idx = connectorInfo.end.index;
            }
            _set(sdkData, 'nvPr.endCxn', obj);
        }
    }
}
